import { render, staticRenderFns } from "./Donners.vue?vue&type=template&id=e789c754"
import script from "./Donners.vue?vue&type=script&lang=js"
export * from "./Donners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports